import { Operator } from '@utils/ApiClient'

export enum FilterFields {
  ClientClientAmountFrom = 'ca_search_ClientAmountFrom',
  ClientClientAmountTo = 'ca_search_ClientAmountTo',
  QueryAmountFrom = 'query_search_AmountFrom',
  QueryAmountTo = 'query_search_AmountTo',
  QueryVolumeFrom = 'query_search_VolumeFrom',
  QueryVolumeTo = 'query_search_VolumeTo',
  ClientVolumeFrom = 'ca_search_VolumeFrom',
  ClientVolumeTo = 'ca_search_VolumeTo',
  ClientPriceFrom = 'ca_search_PriceFrom',
  ClientPriceTo = 'ca_search_PriceTo',
  ClientDateFrom = 'ca_search_DateFrom',
  ClientDateTo = 'ca_search_DateTo',
  ClientName = 'ca_search_ClientName',
  ClientRegistrationDateFrom = 'ca_search_RegistrationDateFrom',
  ClientRegistrationDateTo = 'ca_search_RegistrationDateTo',
  DateFrom = 'DateFrom',
  DateTo = 'DateTo',
  AmountFrom = 'ca_search_AmountFrom',
  AmountTo = 'ca_search_AmountTo',
  TradingAccountsCountFrom = 'ca_search_TradingAccountsCountFrom',
  TradingAccountsCountTo = 'ca_search_TradingAccountsCountTo',
  TradingAccountName = 'ca_search_TradingAccountName',
  Name = 'ca_search_Name',
  SignedUpDateFrom = 'ca_search_SignedUpDateFrom',
  SignedUpDateTo = 'ca_search_SignedUpDateTo',
  VolumeFxmFrom = 'ca_search_VolumeFxmFrom',
  VolumeFxmTo = 'ca_search_VolumeFxmTo',
  VolumeOtherFrom = 'ca_search_VolumeOtherFrom',
  VolumeOtherTo = 'ca_search_VolumeOtherTo',
  TotalCommissionFrom = 'ca_search_TotalCommissionFrom',
  TotalCommissionTo = 'ca_search_TotalCommissionTo',
  RebateAmountFrom = 'ca_search_RebateAmountFrom',
  RebateAmountTo = 'ca_search_RebateAmountTo',
  HasRebate = 'ca_search_HasRebate',
  HasLinkClickedDate = 'ca_search_HasLinkClickedDate',
  HasRegistrationDate = 'ca_search_HasRegistrationDate',
  HasEmailVerifiedDate = 'ca_search_HasEmailVerifiedDate',
  HasActivatedDate = 'ca_search_HasActivatedDate',
  HasFirstCompletedDepositDate = 'ca_search_HasFirstCompletedDepositDate',
  HasFirstClosedTradeDate = 'ca_search_HasFirstClosedTradeDate',
  HasLastClosedTradeDate = 'ca_search_HasLastClosedTradeDate',
  HasTotalCommission = 'ca_search_HasTotalCommission',
  AccumulatedVolumeOtherFrom = 'ca_search_AccumulatedVolumeOtherFrom',
  AccumulatedVolumeOtherTo = 'ca_search_AccumulatedVolumeOtherTo',
  AccumulatedVolumeFxmFrom = 'ca_search_AccumulatedVolumeFxmFrom',
  AccumulatedVolumeFxmTo = 'ca_search_AccumulatedVolumeFxmTo',
  AccumulatedCommissionFrom = 'ca_search_AccumulatedCommissionFrom',
  AccumulatedCommissionTo = 'ca_search_AccumulatedCommissionTo',
  RebateApprovalType = 'ca_search_RebateApprovalType',
  RebatePeriod = 'ca_search_RebatePeriod',
  Country = 'ca_search_Country',
  TradingAccountId = 'ca_search_TradingAccountId',
  ClientId = 'ca_search_ClientId',
  IntroducingBrokerGroupId = 'ca_search_IntroducingBrokerGroupId',
  TradingAccountType = 'ca_search_TradingAccountType',
  RebateGroupId = 'ca_search_RebateGroupId',
  TransactionDateFrom = 'ca_search_TransactionDateFrom',
  StatusChangedAtDateFrom = 'ca_search_StatusChangedAtFrom',
  StatusChangedAtDateTo = 'ca_search_StatusChangedAtTo',
  CreatedDateFrom = 'ca_search_CreatedDateFrom',
  CreatedDateTo = 'ca_search_CreatedDateTo',
  TransactionDateTo = 'ca_search_TransactionDateTo',
  TransactionDateTimeFrom = 'ca_search_TransactionDateTimeFrom',
  TransactionDateTimeTo = 'ca_search_TransactionDateTimeTo',
  ShowNotification = 'ca_search_ShowNotification',
  Entity = 'ca_search_TickmillCompany',
  VolumeSince2019From = 'ca_search_VolumeSince2019From',
  VolumeSince2019To = 'ca_search_VolumeSince2019To',
  VolumeCurrentMonthFrom = 'ca_search_VolumeCurrentMonthFrom',
  VolumeCurrentMonthTo = 'ca_search_VolumeCurrentMonthTo',
  VolumePreviousMonthFrom = 'ca_search_VolumePreviousMonthFrom',
  VolumePreviousMonthTo = 'ca_search_VolumePreviousMonthTo',
  BalanceFrom = 'ca_search_BalanceFrom',
  BalanceTo = 'ca_search_BalanceTo',
  CampaignId = 'ca_search_CampaignId',
  CategoryId = 'ca_search_CategoryId',
  LanguageId = 'ca_search_LanguageId',
  SizeId = 'ca_search_SizeId',
  FxmVolumeFrom = 'query_search_FxmVolumeFrom',
  FxmVolumeTo = 'query_search_FxmVolumeTo',
  OtherVolumeFrom = 'query_search_OtherVolumeFrom',
  OtherVolumeTo = 'query_search_OtherVolumeTo',
  FxmAmountFrom = 'query_search_FxmAmountFrom',
  FxmAmountTo = 'query_search_FxmAmountTo',
  OtherAmountFrom = 'query_search_OtherAmountFrom',
  OtherAmountTo = 'query_search_OtherAmountTo',
  LinkClickedDateFrom = 'ca_search_LinkClickedDateFrom',
  LinkClickedDateTo = 'ca_search_LinkClickedDateTo',
  EmailVerifiedDateFrom = 'ca_search_EmailVerifiedDateFrom',
  EmailVerifiedDateTo = 'ca_search_EmailVerifiedDateTo',
  ActivatedDateFrom = 'ca_search_ActivatedDateFrom',
  ActivatedDateTo = 'ca_search_ActivatedDateTo',
  FirstCompletedDepositDateFrom = 'ca_search_FirstCompletedDepositDateFrom',
  FirstCompletedDepositDateTo = 'ca_search_FirstCompletedDepositDateTo',
  FirstClosedTradeDateFrom = 'ca_search_FirstClosedTradeDateFrom',
  FirstClosedTradeDateTo = 'ca_search_FirstClosedTradeDateTo',
  LastClosedTradeDateFrom = 'ca_search_LastClosedTradeDateFrom',
  LastClosedTradeDateTo = 'ca_search_LastClosedTradeDateTo',
  HasTradingAccounts = 'query_search_HasTradingAccounts',
}
export type FilterQueryPropsValue =
  | { value: string | number; operator: Operator }
  | string
  | number
  | undefined

export interface FilterQueryProps {
  [key: string]: FilterQueryPropsValue
}
